<template>
  <div class="schools-dropdown">
    <PillDropdown
      name="Schools"
      :options="schools"
    >
    </PillDropdown>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import PillDropdown from './PillDropdown.vue';
const route = useRoute();
const store = useStore();

const schools = computed(() => {
  const allOrgs = store.state.organizations.map((school) => {
    return { name: school.name, org_id: school.id, checked: false };
  });
  allOrgs.map((org, index) => {
    if (route.query?.secondary_organizations?.includes(org.org_id)) {
      return (allOrgs[index].checked = true);
    }
  });
  return allOrgs;
});
</script>
